export default __webpack_public_path__ + "static/media/loader.93d5b01a.gif";